import { Box, Loading, Text } from 'ui'
import type React from 'react'
export function MetricBox({
  title,
  value,
  children,
  isLoading,
}: {
  title: string
  value: string
  children?: React.ReactNode
  isLoading?: boolean
}) {
  return (
    <Box
      border="1px solid"
      borderColor="neutrals.100"
      borderRadius="large"
      p={3}
      flex={1}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <Text color="lightText" mb={2} fontSize="1">
            {title}
          </Text>
          <Text fontSize="9" fontWeight="500">
            {value}
          </Text>
          {children}
        </>
      )}
    </Box>
  )
}
